import ChangePasswordForm from "./ChangePasswordForm";

export default ChangePasswordForm;
